import { Component, Input } from '@angular/core';
import { UserService } from '../../../../services/user.service';
import { NgFor, NgIf } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { RebillingService } from '../../../../services/rebilling.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { PaymentPlanResponse } from '../../../../models/responses/payment-plan-response';
import { MatDividerModule } from '@angular/material/divider';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CreateCustomPlanDialogComponent } from '../create-custom-product-dialog/create-custom-product-dialog.component';
import { CustomPaymentPlanComponent } from '../../../payment/custom-payment-plan/custom-payment-plan.component';
import { UserResponse } from '../../../../models/responses/user-response';
import { localStoragevarNames } from '../../../../utilities/local-storage-utils';

@Component({
  selector: 'app-configure-payment-plans',
  standalone: true,
  imports: [
    NgIf,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatDividerModule,
    MatDialogModule,
    NgFor,
    CustomPaymentPlanComponent
  ],
  templateUrl: './configure-payment-plans.component.html',
  styleUrl: './configure-payment-plans.component.scss'
})
export class ConfigurePaymentPlansComponent {
  isLoading = false;
  isRebillingSetup = false;
  paymentPlanForm!: FormGroup;
  rebillingPriceId: number | null = null;
  userId!: number;
  plans: PaymentPlanResponse[] = [];

  constructor(
    private userService: UserService,
    private rebillingService: RebillingService,
    private dialog: MatDialog,
    private formBuilder: FormBuilder) { }


  ngOnInit() {
    this.fetchLoggedUser();
  }

  initFormGroup() {
    this.paymentPlanForm = this.formBuilder.group({
      productName: [undefined, [Validators.required]],
      productDescription: [undefined, [Validators.required]],
      monthlyPricing: [undefined, [Validators.required]],
      overageCharge: [undefined, [Validators.required]],
      overageLimit: [undefined, [Validators.required]]
    });
  }

  onStripeConnectRequest() {
    this.isLoading = true;
    this.rebillingService.createStripeConnectUrl().subscribe({
      next: (data) => {
        document.location.href = data.url;
      },
      error: () => {
        this.isLoading = false;
        alert('Error from server contact support');
      }
    });
  }

  fetchLoggedUser() {
    this.isLoading = true;

    this.userService.fetchLoggedUser().subscribe({
      next: (user) => {
        if (user.stripeRebillingInfo) {
          this.userId = user.id;
          this.rebillingPriceId = user.stripeRebillingInfo.id;
          this.fetchRebillingPlans(user.id);
          this.isRebillingSetup = user.stripeRebillingInfo.setUpCompleted;
        } else {
          this.isLoading = false;
        }
      },
      error: () => {
        this.isLoading = false;
        alert('Error from server contact support');
      }
    });
  }

  onCreatePlan() {
    if (this.rebillingPriceId) {
      const dialogRef = this.dialog.open(CreateCustomPlanDialogComponent, {
        width: '50%',
        data: { rebillingInfoId: this.rebillingPriceId }
      });

      dialogRef.afterClosed().subscribe(() => {
        this.fetchRebillingPlans(this.userId);
      })
    } else {
      alert('UI error,contact support');
    }
  }

  fetchRebillingPlans(mainAccountId: number) {
    this.isLoading = true;

    this.rebillingService.fetchPaymentPlans(mainAccountId).subscribe({
      next: (plans) => {
        this.plans = plans;
        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
        alert('Error from server contact support');
      }
    });
  }
}
